export default __webpack_public_path__ + "static/static-asset-uswitchBestValue2021-a4bb045173e210e928e97bbe46e8d84c.svg";